import { render, staticRenderFns } from "./BContainer.vue?vue&type=template&id=08433ed0"
import script from "./BContainer.vue?vue&type=script&lang=js"
export * from "./BContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports